/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type NylasWebhookChallengeParams = {
/**
 * Opaque token Nylas expects echoed back verbatim.
 * @minLength 1
 * @maxLength 512
 */
challenge: string;
};
